const IOS_PROJECTION_FALLBACK_KEY = 'reef-tracker.ios-projection-fallback.v2';

export function hasIOSProjectionFallback() {
  try {
    return window.sessionStorage.getItem(IOS_PROJECTION_FALLBACK_KEY) === 'mercator';
  } catch (_) {
    return false;
  }
}

export function persistIOSProjectionFallback(enabled: boolean) {
  try {
    if (enabled) {
      window.sessionStorage.setItem(IOS_PROJECTION_FALLBACK_KEY, 'mercator');
      return;
    }

    window.sessionStorage.removeItem(IOS_PROJECTION_FALLBACK_KEY);
  } catch (_) {}
}

export function shouldFallbackFromGlobe(error?: Error) {
  const details = `${error?.name ?? ''} ${error?.message ?? ''}`.trim();
  if (!details) return false;

  return /\b(globe|projection|webgl|context|worker|render|shader|framebuffer|vertex|fragment|gpu|TypeError|ReferenceError)\b/i.test(details);
}
